export default __webpack_public_path__ + "static/object-tile-size-dark-5d10a84462e04d1f22d0471675834cd5.png";